import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/NeighborhoodSidebar.css';

const NeighborhoodSidebar = ({ activeFilter, setActiveFilter }) => {
	
  const navigate = useNavigate();

  const handleFilterClick = (filter) => {
    setActiveFilter(prev => (prev === filter ? null : filter));
    // Add logic to update map layers here
  };

  const filters = [
    { id: 'commute', label: '🚲 Commute' },
    { id: 'rentalAvailability', label: '🏘️ Rental Availability' },
    { id: 'rentalCost', label: '💲 Rental Cost' },
    { id: 'safety', label: '🛡️ Safety' },
  ];

  return (
    <div className="sidebar">
	  <div className="return-section">
        <button className="return-button" onClick={() => navigate('/profile')}>
          ← Return to Dashboard
        </button>
      </div>

      <h3 className="sidebar-title">Neighborhood Details</h3>
      <div className="sidebar-section">
        {filters.map(({ id, label }) => (
          <button
            key={id}
            className={`sidebar-button ${activeFilter === id ? 'active' : ''}`}
            onClick={() => handleFilterClick(id)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NeighborhoodSidebar;
